// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useUserServiceRequests: () => UseQueryResult<
  TemplateContract<UserServiceRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCredentialUserServiceRequests', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryCredentialUserServiceRequests(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useUserServiceRequests;
